const isDevelopment: boolean = ['local', 'development', 'staging'].includes(
  import.meta.env.VITE_APP_ENV,
);

type LogMethod = (...args: unknown[]) => void;

interface Logger {
  log: LogMethod;
  warn: LogMethod;
  error: LogMethod;
}

const logger: Logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  error: (...args) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
};

export default logger;
